import { Util } from '../../utils/common.utils';
import { AnalyticsJourney, AnalyticsModel } from '../constants/analytics-journey';
import {
  AnalyticsJourneyKey,
  AppLoadStep,
  CommonStep,
  ConfirmPackageStep,
  CreateCustomerStep,
  JourneyEvent,
  PaymentStep,
} from '../enums/analytics-journey-key';
import { AnalyticsEvent } from '../models/customer/analytics';

export const AnalyticsStore = {
  user: {} as any,
  isInitialized: false,
  events: {
    current: [],
    previous: [],
  } as any,

  get currentJourney() {
    return AnalyticsStore.events.current[0]?.journey as AnalyticsJourneyKey;
  },

  initialize: (userDetails: any, locale: string, customerNumber: string, countryCode: string) => {
    if (AnalyticsStore.isInitialized) {
      return Promise.resolve(AnalyticsStore);
    }

    AnalyticsStore.user = {
      user_email: Util.convertToHash(userDetails.email),
      user_phone: Util.convertToHash(userDetails.mobileNumber),
      user_first_name: Util.convertToHash(userDetails.name),
      user_last_name: Util.convertToHash(userDetails.lastName),
      user_zipcode: Util.convertToHash(userDetails.countryCode),
      user_country: Util.convertToHash(countryCode),
      user_id: Util.convertToHash(customerNumber),
      user_city: '',
      user_region: Util.convertToHash(locale),
    };
    AnalyticsStore.isInitialized = true;
    const w = window as any;
    w.dataLayer = w.dataLayer || [
      [
        'set',
        'user_properties',
        {
          mcg_user_id: '',
          mcg_user_hashed_email: '',
          mcg_user_connect_id: '',
          mcg_user_segment_id: '',
          mcg_user_billing_id: '',
          mcg_user_login_type: 'guest',
          mcg_user_subscriber_type: '',
          mcg_platform_language: 'en',
          mcg_platform_cc: 'za',
        },
      ],
    ];

    const userPropertyIndex = w.dataLayer.findIndex((item: any) =>
      Object.prototype.hasOwnProperty?.call(item, 'length')
        ? [...item].findIndex((item) => item === 'user_properties')
        : null
    );
    const mcgDataIndex = userPropertyIndex !== -1 ? (w.dataLayer[userPropertyIndex][2] ? 2 : -1) : -1;
    if (userPropertyIndex !== -1 && mcgDataIndex !== -1) {
      w.dataLayer[userPropertyIndex][mcgDataIndex].mcg_user_id = customerNumber;
      w.dataLayer[userPropertyIndex][mcgDataIndex].mcg_user_login_type = 'authenticated';
      w.dataLayer[userPropertyIndex][mcgDataIndex].mcg_user_hashed_email = Util.convertToHash(userDetails.email);
      w.dataLayer[userPropertyIndex][mcgDataIndex].mcg_user_connect_id = userDetails.connectId;
      w.dataLayer[userPropertyIndex][mcgDataIndex].mcg_user_segment_id = localStorage.getItem('_Invidi') || '';
      w.dataLayer[userPropertyIndex][mcgDataIndex].mcg_user_billing_id = userDetails.agreementId ?? '';
    }

    w.mcgDataLayer = w.mcgDataLayer || {
      ecommerce: {
        event: '',
        products: [],
      },
      user: {},
    };
    w.mcgDataLayer.user = {
      user_id: customerNumber,
      hashed_email: Util.convertToHash(userDetails.email),
      connect_id: userDetails.connectId,
      segment_id: localStorage.getItem('_Invidi') || '',
      billing_id: userDetails.agreementId ?? '',
      subscriber_type: '',
      login_type: 'authenticated',
    };

    return Promise.resolve(AnalyticsStore);
  },

  changeEvents: (event: any) => {
    AnalyticsStore.events.current.push(event);
  },

  addEvent: (eventKey: any, info: any, updateMcgDataLayer: boolean, updateDataLayer: boolean, validate?: boolean) => {
    if (AnalyticsStore.currentJourney) {
      if (validate && AnalyticsStore.events.current.find((event: any) => event.key === eventKey)) {
        return;
      }
      AnalyticsStore.events.current.push({
        key: eventKey,
        ...AnalyticsJourney[AnalyticsStore.currentJourney][eventKey](info, AnalyticsStore.user),
      });
      AnalyticsStore.setDataLayer(
        AnalyticsJourney[AnalyticsStore.currentJourney][eventKey](info, AnalyticsStore.user),
        updateMcgDataLayer,
        updateDataLayer
      );
    }
  },

  addJourneyEvent: (
    eventKey: CommonStep | AppLoadStep | CreateCustomerStep | ConfirmPackageStep | PaymentStep | JourneyEvent,
    info?: AnalyticsModel
  ) => {
    if (AnalyticsStore.currentJourney) {
      if (AnalyticsStore.events.current.find((event: any) => event.key === eventKey)) {
        return;
      }
      AnalyticsStore.events.current.push({
        key: eventKey,
        ...AnalyticsJourney[AnalyticsStore.currentJourney][eventKey](info),
      });
    }
  },

  startJourney: (eventKey: AnalyticsJourneyKey, info?: AnalyticsModel) => {
    if (AnalyticsStore.events.current[0]?.journey !== eventKey) {
      AnalyticsStore.events.previous = { ...AnalyticsStore.events.current };
      AnalyticsStore.events.current.push({
        key: CommonStep.StartJourney,
        ...AnalyticsJourney[eventKey][CommonStep.StartJourney](info),
      });
    }
  },

  setDataLayer: (analyticsEvent: AnalyticsEvent, updateMcgDataLayer: boolean, updateDataLayer: boolean) => {
    const w = window as any;
    if (updateMcgDataLayer) {
      w.mcgDataLayer = w.mcgDataLayer || {
        ecommerce: {
          event: '',
          products: [],
        },
      };
      w.mcgDataLayer.ecommerce.event = analyticsEvent?.event;
      w.mcgDataLayer.ecommerce.products = analyticsEvent?.ecommerce?.items;
    }

    if (updateDataLayer) {
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push(analyticsEvent);

      w.dataLayer.push({
        event: 'Reset_Ecom',
        ecommerce: undefined,
      });
    }
  },
};
